import React from 'react';
import { Link } from 'react-router-dom';
import '../estilo.css';

export default class Contato extends React.Component {
  render() {
    return (
      <div id="contact" className="container-fluid bg-grey contact-container">
        <h2 className="text-center contact-title">Contato</h2>

        <div className="row">
          {/* Bloco de texto / chamada */}
          <div className="col-sm-12 text-center" style={{ marginBottom: '30px' }}>
            <p><h3>
              Tem dúvidas sobre o <strong>Quantum Trades EA</strong>, planos, instalação ou
              configuração? Fale com a nossa equipe ou entre nos canais oficiais.</h3>
            </p>
            <p>
              <h4>Estamos disponíveis para ajudar você a utilizar o robô da melhor forma possível.</h4>
            </p>
          </div>
        </div>

        <div className="row">
          {/* Informações de contato direto */}
          <div className="col-sm-6 contact-info">
            <h3>Atendimento</h3>
            <p>
              <span className="bi bi-map contact-icon"></span> Brasil
            </p>
            <p>
              <span className="bi bi-whatsapp contact-icon"></span>
              <a
                href="https://wa.me/5542984241307"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              > 
                 (42) 98424-1307 — WhatsApp
              </a>
            </p>
            <p>
              <span className="bi bi-mailbox contact-icon"></span>
              <a
                href="mailto:contato@quantumtrades.com.br"
                className="contact-link"
              >
                 contato@quantumtrades.com.br
              </a>
            </p>
          </div>

          {/* Redes sociais / comunidade */}
          <div className="col-sm-6 contact-info">
            <h4>Canais Oficiais</h4>
            <p>
              <span className="bi bi-youtube contact-icon"></span>
              <a
                href="https://www.youtube.com/@QuantumTradesBR"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                YouTube: @QuantumTradesBR
              </a>
            </p>
            <p>
              <span className="bi bi-telegram contact-icon"></span>
              <a
                href="https://t.me/QuantumTradesBr"
                target="_blank"
                rel="noopener noreferrer"
                className="contact-link"
              >
                Grupo no Telegram
              </a>
            </p>
            <p>
              <span className="bi bi-house-add-fill contact-icon"></span>
              <Link to="/cadastro" className="contact-link">
                Cadastro para acesso ao EA
              </Link>
            </p>
          </div>
        </div>
      </div>
    );
  }
}
